import React, { useState, useEffect, useRef } from 'react';

interface Props {
	onChange: (event: number) => void;
	value: string | number;
	disabled?: boolean;
	unit?: string;
	min?: number;
	max?: number;
}

export default function PixelInput(props: Props) {
	const {
		onChange,
		value = 0,
		disabled = false,
		unit = "px",
		min = null,
		max = 120
	} = props;

	const [focused, setFocused] = useState(false);
	const [inputValue, setInputValue] = useState<string | number>(value);
	const onChangeTimeout = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		return () => {
			if (onChangeTimeout.current) {
				clearInterval(onChangeTimeout.current);
				onChangeTimeout.current = null;
			}
		};
	}, []);

	useEffect(() => {
		//when props.value changes, if they're typing, don't apply it
		if (!focused) {
			setInputValue(value);
		}
	}, [value]);

	function handleInput(event: React.ChangeEvent<HTMLInputElement>) {
		var value = Number(event.target.value.replace(/[^0-9.]/g, ''))
		if (min != null)
			value = Math.max(value, min);
		if (max != null)
			value = Math.min(value, max);
		const newValue = value;
		if (inputValue !== 0 && newValue === 0) {
			setInputValue(0);
		}
		setInputValue(newValue);

		if (onChangeTimeout.current) {
			clearTimeout(onChangeTimeout.current);
			onChangeTimeout.current = null;
		}

		onChangeTimeout.current = setTimeout(() => {
			onChange(newValue);
			if (onChangeTimeout.current) {
				onChangeTimeout.current = null;
			}
		}, 300);
	}

	function handleFocus(e: React.FocusEvent<HTMLInputElement>) {
		setFocused(true);
		if (!value) {
			setInputValue('');
		} else {
			setInputValue(value);
		}
	}

	function handleBlur() {
		setFocused(false);
		setInputValue(value);
	}

	return (
		<div className="pixel-input">
			<input
				disabled={disabled}
				className="pixel-input"
				onBlur={handleBlur}
				onFocus={handleFocus}
				type={focused ? 'number' : 'text'}
				onChange={handleInput}
				value={inputValue + (!focused && unit ? unit : '')}
			/>
		</div>
	);
}